<mat-card class="p-0">
  <mat-card-title>
    <div class="card-title-text">
      {{titolo}}
    </div>
  </mat-card-title>
  <mat-card-content>
    <form [formGroup]='frmInserimento' class='inserimento-form'>
      <div class="container">

        <div class="row" *ngIf="isEdit">
          <div class="col-md-4">
            <mat-form-field class="full-width">
              <input formControlName="Descrizione"
                     id="Descrizione" matInput
                     placeholder="Descrizione">
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <div class="mat-form-field">
              <mat-checkbox id="Visibile" formControlName="Visibile">
                Visibile
              </mat-checkbox>
            </div>
          </div>
        </div>

      </div>

      
      <div mat-dialog-actions>
        <button mat-raised-button color="primary"
                (click)="btnAnnulla()">
          Annulla
        </button>
        <button mat-raised-button color="primary"
                [disabled]="!frmInserimento.valid"
                (click)="btnSalva()"
                cdkFocusInitial>
          Salva
        </button>
      </div>
    </form>
  </mat-card-content>
</mat-card>
<style>

  .inserimento-form {
    min-width: 150px;
    max-width: 720px !important;
    width: 100%;
  }

  /* .full-width {
      width: 100%;
    }*/
</style>

